import React from 'react';
import cx from 'classnames';
import Col from '../GridSystem/Col';
import Row from '../../components/GridSystem/Row';
import styles from './Card.module.scss';

function CardFooter(props) {
  const { className, children, ...rest } = props;
  return (
    <Col xs={12} className={cx(styles.footer, className)} {...rest}>
      <Row className={styles.footerRow}>{children}</Row>
    </Col>
  );
}

export default CardFooter;
